import React from 'react';
import { Pie } from 'react-chartjs-2';
import { ArcElement, Tooltip, Legend, Chart } from 'chart.js';

Chart.register(ArcElement, Tooltip, Legend);

const PieChart = ({sales, field}) => {
    let labelsEl = [];
    let dataEl = [];
    let dataChart = {
        labels: [],
        datasets: [
            {
            },
        ],
    };

    const groupAndSum = (data, field) => { 
        return data.reduce((acc, item) => { 
            if (!acc[item[field]]) { 
                acc[item[field]] = 0; 
            } 
            
            acc[item[field]] += parseFloat(item.amount); 
            return acc; 
        }, {});
    };    

    const generarColoresAleatorios = (n) => { 
        const colores = []; 
        for (let i = 0; i < n; i++) { 
            const rojo = Math.floor(Math.random() * 255); 
            const verde = Math.floor(Math.random() * 255); 
            const azul = Math.floor(Math.random() * 255); 
            colores.push(`#${rojo.toString(16).padStart(2, '0')}${verde.toString(16).padStart(2, '0')}${azul.toString(16).padStart(2, '0')}`); 
        } 
        return colores;
    }
    
    if(sales && sales.length > 0){
        const groupedData = groupAndSum(sales, field);
        labelsEl = Object.keys(groupedData);
        dataEl = Object.values(groupedData);

        dataChart = {
            labels: labelsEl,
            datasets: [
                {
                    data: dataEl,
                    backgroundColor: generarColoresAleatorios(dataEl.length), 
                    hoverBackgroundColor: generarColoresAleatorios(dataEl.length), 
                }
            ]
        };
    };

    const options = {
        responsive: true,
        maintainAspectRatio: true,
    };
    
    return (
        <div>
            <Pie data={dataChart} options={options} />
        </div>
    );
}

export default PieChart;